import { Badge } from "@pushpress/pushpress-ui";
import { useAnalytics } from "../../../components/providers/AnalyticsProvider";
import { AccountEvent } from "../constants/account.events";

type AccountSubscriptionDetailsProps = {
  title: string;
  description: string;
  status: string;
};

const AccountSubscriptionDetails = ({
  title,
  description,
  status,
}: AccountSubscriptionDetailsProps) => {
  const { trackEvent } = useAnalytics();
  const paymentStatuses = [
    "incomplete",
    "incomplete_expired",
    "past_due",
    "unpaid",
    "paused",
  ];
  const trailingStatuses = ["trialing"];

  const isPaymentFailed = paymentStatuses.includes(status);
  const isTrailing = trailingStatuses.includes(status);

  if (!title || !description) {
    trackEvent(AccountEvent.InvalidSubscriptionInfo, {
      location: "Account Page",
      subSection: "Account Info Card",
    });
    return null;
  }

  return (
    <div className="tw-p-4 tw-w-full md:tw-w-[250px]">
      <div className="tw-flex tw-flex-col tw-mb-3">
        <h3 className="tw-text-[18px]">{title}</h3>
        {isPaymentFailed && (
          <Badge variant="warning" className="tw-w-fit tw-mt-2">
            Payment required
          </Badge>
        )}
        {isTrailing && (
          <Badge variant="outline" className="tw-w-fit tw-mt-2">
            Trialing
          </Badge>
        )}
      </div>
      <p className="tw-text-sm tw-text-neutral-500 tw-leading-tight">
        {description}
      </p>
    </div>
  );
};

export default AccountSubscriptionDetails;
